export const PropertyType = {
    Seeds: 2,
    Fertilizers: 3,
    Pesticides: 4,
    Harvest: 5
};

export const OperationType = {
    Seeds: 0,
    Fertilizers: 1,
    Pesticides: 2,
    Harvests: 3
};

export const EventActionType = {
    Purchase: 0,
    OwnProduction: 2,
    StartAmount: 4,
    FromSilo: 6
};

export const SeedQuality = {
    Certified: 6,
    FarmSeed: 16,
    Other: 17
};
